<template>
    <div class="show-hosting-downgrade-modal-intro">
        <div class="text-container">
            <p class="step-title">
                Sure you want to stop hosting with Fusebox?
            </p>
            <p class="step-description">
                Changing hosts can often be a lot of work. While you definitely can host your show somewhere else, we’d like to review what you’ll be misssing.
            </p>
        </div>

        <div class="benefits-container">
            <hosting-benefits
                styling="downgrade"
            />
        </div>

        <div class="primary-action-container">
            <base-form-button
                class="btn is-red"
                @click.native.prevent="$emit('change-step-next')"
            >
                Yes, I am still switching to a different host
            </base-form-button>
        </div>

        <div class="secondary-action-container">
            <a href="#" class="cancel-action" @click.prevent="closeModal">
                I changed my mind. I want to stay with Easy Hosting!
            </a>
        </div>
    </div>
</template>
<script>
import { mapMutations } from 'vuex';
import HostingBenefits from '@/components/Shows/AddOns/HostingBenefits';

export default {
    components: {
        HostingBenefits,
    },

    methods: {
        ...mapMutations(['changeUIState']),

        /**
         * Closes modal.
         */
        closeModal() {
            this.changeUIState({ showHostingDowngradeModal: { visible: false } });
        },
    },
};
</script>
